import moment from 'moment'
import storage from 'good-storage'

// const version = storage.get('version') || ''
// const token = storage.get('token') || ''
// const commonData = {
//   privatefield: '',
//   reqtime: moment().format('YYYY-MM-DD HH:mm:ss'),
//   version: version === '' ? 'V20180412' : version.version,
//   accesstoken: token.accessToken === '' ? '' : token.accessToken
// }
let clientId = 'web_pmi'
let clientSecret = 'web_pmi'

if (location.host.indexOf('localhost') >= 0) {
  clientId = 'web_pmi'
  clientSecret = 'web_pmi'
} else if (location.host.indexOf('pm.xb969.com') >= 0) {
  clientId = 'web_pmi'
  clientSecret = 'web_pmi'
} else if (location.host.indexOf('pmi.xb969.com') >= 0) {
  clientId = '565718a9-b7c9-4b5c-a8c9-48654738fa22'
  clientSecret = 'b4ca051e-c8a9-4cd5-88a7-662365c59561'
} else if (location.host.indexOf('xgx.xb969.com') >= 0) {
  clientId = '565718a9-b7c9-4b5c-a8c9-48654738fa22'
  clientSecret = 'b4ca051e-c8a9-4cd5-88a7-662365c59561'
}


function getCommonData () {
  const version = storage.get('version') || ''
  const token = storage.get('token') || ''
  const commonData = {
    privatefield: '',
    reqtime: moment().format('YYYY-MM-DD HH:mm:ss'),
    version: version === '' ? 'V20180412' : version.version,
    accesstoken: token.accessToken === '' ? '' : token.accessToken,
    clientType: 'WebH5'
  }
  return commonData
}

function getEndDay (endDate) {
  let _endDate = moment(endDate)
  let longTime = _endDate.diff(moment())
  let hour = longTime / (60 * 60 * 1000)
  let day = Math.round(hour / 24)
  return day + '天后到期'
}
export {
  getCommonData,
  clientId,
  clientSecret,
  getEndDay
}



// WEBPACK FOOTER //
// ./src/common/js/reqdata.js